import {IS_DEV} from '@sdox/utils/dom'

export const SENTRY_DSN = '9938145d691f437380ac0f2afecc0bcf'
export const SENTRY_PROJ_NR = 5

export const BASE_URL = IS_DEV ? 'http://localhost:8000' : ''
export const BASE_ADMIN_URL = IS_DEV ? 'http://127.0.0.1:8000' : 'https://prod.sdox-intern.de'
